/* eslint-disable @typescript-eslint/no-require-imports */
'use strict';

// Polyfill for ReactDOM.findDOMNode removed in React 19.
// Used by legacy deps: react-select v3, react-onclickoutside (via react-datepicker),
// react-input-mask, react-transition-group (via MUI, sdui, react-select).
// Remove this shim once all those deps are upgraded.

// Solutions:
// react-input-mask - replace legacy package task
// react-select - update react-select task
// react-transition-group - update mui task
// react-onclickoutside - update react-datepicker task

// `react-dom-original` is a webpack alias that resolves to the actual
// react-dom package, bypassing the `react-dom$` alias that points back here.
const ReactDOM = require('react-dom-original');

function findHostNode(fiber) {
  if (!fiber) return null;
  if (typeof Element !== 'undefined' && fiber.stateNode instanceof Element) {
    return fiber.stateNode;
  }
  let child = fiber.child;
  while (child) {
    const node = findHostNode(child);
    if (node) return node;
    child = child.sibling;
  }
  return null;
}

function findDOMNode(instanceOrNode) {
  if (instanceOrNode == null) return null;
  if (typeof Element !== 'undefined' && instanceOrNode instanceof Element) {
    return instanceOrNode;
  }
  const fiber = instanceOrNode._reactInternals || instanceOrNode._reactInternalFiber;
  if (fiber) return findHostNode(fiber);
  return null;
}

if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = findDOMNode;
}

module.exports = ReactDOM;
